import { useState } from "react";

import { useTranslator } from "@/i18n/useTranslator";
import { HeaderButton } from "@/src/blocks/HeaderButton";
import { NewSiteForm } from "@/src/components/admin/NewSiteForm";
import { RightPanel } from "@/src/components/RightPanel";

export const SitesPageHeaderButton = () => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const { t } = useTranslator();

  return (
    <>
      <RightPanel
        controlledOpen={isPanelOpen}
        setControlledOpen={setIsPanelOpen}
        title={t("site.title")}
        content={
          <div className="m-4">
            <NewSiteForm onSuccess={() => setIsPanelOpen(false)} />
          </div>
        }
        onDrawerClosed={() => setIsPanelOpen(false)}
      />
      <HeaderButton
        buttons={[
          {
            i18nKey: "site.new_site",
            handleOnClick: () => setIsPanelOpen(true),
            icon: "Plus",
          },
        ]}
      />
    </>
  );
};
